module.exports = "/assets/c7f732b8a8d2bb65e7d09c3137cd6d77.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/BG.png
// module id = 2358
// module chunks = 0